import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Services() {
  const [svcs, setSvcs] = useState([]);
  const [logs, setLogs] = useState({ name: '', text: '' });

  const load = () => api.get('/services').then(r => setSvcs(r.data));
  useEffect(() => { load(); const i = setInterval(load, 5000); return () => clearInterval(i); }, []);

  const action = async (name, act) => { await api.post(`/services/${name}/${act}`); load(); };
  const seeLogs = async (name) => { const r = await api.get(`/services/${name}/logs`); setLogs({ name, text: r.data.logs }); };

  return (
    <>
      <div className="page-title"><h1>Serviços</h1></div>
      <table>
        <thead><tr><th>Nome</th><th>Estado</th><th>Status</th><th>Ações</th></tr></thead>
        <tbody>
          {svcs.map(s => (
            <tr key={s.id}>
              <td><strong>{s.name}</strong></td>
              <td><span className={'badge ' + (s.state==='running'?'ok':'err')}>{s.state}</span></td>
              <td>{s.status}</td>
              <td>
                <button className="secondary" onClick={() => action(s.name, 'restart')}>Restart</button>{' '}
                {s.state === 'running'
                  ? <button className="ghost" onClick={() => action(s.name, 'stop')}>Stop</button>
                  : <button className="ghost" onClick={() => action(s.name, 'start')}>Start</button>}
                {' '}<button className="ghost" onClick={() => seeLogs(s.name)}>Logs</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {logs.name && (
        <div className="modal-bg" onClick={() => setLogs({name:'',text:''})}>
          <div className="modal" onClick={e=>e.stopPropagation()} style={{width:'90vw', maxWidth:'1100px'}}>
            <h2>Logs — {logs.name}</h2>
            <pre className="code" style={{maxHeight:'60vh', overflow:'auto'}}>{logs.text}</pre>
            <div className="modal-actions"><button onClick={() => setLogs({name:'',text:''})}>Fechar</button></div>
          </div>
        </div>
      )}
    </>
  );
}
